import { debounce } from "./helpers";

const verticalAutoSliders = [];
export const verticalAutoSlider = (el, userSettings) => {
    let current = 0;
    let last_set;

    const settings = {
        startWidth: 768,
        interval: 3000,
        speed: 1000,
        ...userSettings,
    };

    el.style.setProperty("--speed", settings.speed + "ms");

    const setSize = (el) => {
        let set = window.innerWidth <= settings.startWidth;
        el.classList.toggle("init", set);
        if (set != last_set && !set) {
            el.querySelectorAll("item").forEach((el) => {
                el.classList.remove("active", "last");
            });
        }
        last_set = set;
    };

    const resized = () => {
        verticalAutoSliders.forEach((el) => {
            setSize(el);
        });
    };

    const totalItems = el.querySelectorAll(".item").length;
    const fixNth = (num) => {
        if (num < 0) {
            return totalItems;
        }
        if (num >= totalItems) {
            return 1;
        }
        return num + 1;
    };

    const showNext = () => {
        let lastEl = el.querySelector(
            ".item:nth-child(" + fixNth(current - 1) + ")",
        );
        let currEl = el.querySelector(
            ".item:nth-child(" + fixNth(current) + ")",
        );
        let nextEl = el.querySelector(
            ".item:nth-child(" + fixNth(current + 1) + ")",
        );

        lastEl.classList.remove("active");
        lastEl.classList.add("last");
        currEl.classList.add("active");
        nextEl.classList.add("next");
        nextEl.classList.remove("last");

        current++;
        if (current >= totalItems) {
            current = 0;
        }
    };

    setInterval(showNext, settings.interval);
    showNext();

    if (verticalAutoSliders.length == 0) {
        window.addEventListener("resize", debounce(resized, 10));
    }

    setSize(el);

    verticalAutoSliders.push(el);
};
